import React from 'react';

import { SubRoutes } from '../../routes';

import FeeMonthlyPage from './_feeMonthly';
import FeeSettingPage from './_feeSetting';
import FeeSettingDetailPage from './_feeSettingDetail';

const MainAccountingPage = () => {
  return <SubRoutes name="accounting" />;
};

const Accounting = {
  MainAccountingPage,
  FeeSettingDetailPage,
  FeeMonthlyPage,
  FeeSettingPage,
};

export default Accounting;
